
import { Modal } from "react-bootstrap";
import { SelectColumn } from "react-data-grid"
import DataGrid from 'react-data-grid';
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import { useEffect, useState } from "react";
import { enumUtil } from "../../../utils/Enum";
import Loader from "../Loader/Loader";
import ModalHeader from "../../Setup/Shared/ModalHeader";
import Pagination from "../Pagination/Pagination";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import isNull from "../../../utils/NullChecking";
const DiagnosisSearch = (props) => {
    const { isOpenICDSearch, onCloseICD, handleSelectDiagnosis, onRowSelection, rowKeyGetter, selectedRows, Name, PatientID } = { ...props }
    const [searchParam, setSearchParam] = useState(null)
    const [searchParamDX, setSearchParamDX] = useState(null)

    const API_URL = enumUtil.controller.Claim
    const [isLoading, setIsLoading] = useState(false)
    const [recICD, setRecICD] = useState([])
    const [recDxData, setRecDxData] = useState([])

    const [active, setActive] = useState(false)
    const [recOpened, setRecOpened] = useState(false)

    const [PerPage, setPerPage] = useState("100")
    const [PageNo, setPerPageNo] = useState("1")
    const [TotalPages, setTotalPages] = useState();
    const dgheading = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', }}>Diagnosis History</p>;
    };
    const handlePageClick = (page) => { setPerPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPerPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPerPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPerPageNo(1)
    }
    // const columnsAll = [
    //     {
    //         ...SelectColumn,
    //     },
    //     {
    //         key: 'DiagnosisCode',
    //         name: (
    //             <div className="column-container">
    //                 <span>Diagnosis Code</span>
    //             </div>
    //         ),
    //         width: 150,
    //     },
    //     {
    //         key: 'Description',
    //         name: (
    //             <div className="column-container">
    //                 <span>Description</span>
    //             </div>
    //         ),
    //         width: 292,
    //         renderCell: ({ row }) => {
    //             return (
    //                 <div className="validation_message" title={row.Description}>{row.Description}</div>
    //             );
    //         },
    //     },
    //     {
    //         key: 'Inactive',
    //         name: 'Inactive',
    //         width: 140,
    //         cellClass: 'last-column',
    //         headerCellClass: 'last-column',
    //     },
    // ]
    const columnsRecentlyAdded = [
        {
            ...SelectColumn,
        },
        {
            key: 'DiagnosisCode',
            name: (
                <div className="column-container">
                    <span>Code</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 100,
        },
        {
            key: 'Description',
            name: (
                <div className="column-container">
                    <span>Description</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 243,
            renderCell: ({ row }) => {
                return (
                    <div className="validation_message" title={row.Description}>{row.Description}</div>
                );
            },
        },
        {
            key: 'AddedBy',
            name: (
                <div className="column-container">
                    <span>Added By</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 120,

        },
        {
            key: 'AddedDate',
            cellClass: 'last-column',
            headerCellClass: 'last-column',
            name: (
                <div className="column-container">
                    <span>Added Date</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 120,
        },
    ]
    const columnsPatientDx = [
        {
            ...SelectColumn,
        },
        {
            key: 'DiagnosisCode',
            name: (
                <div className="column-container">
                    <span>Code</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 100,
        },
        {
            key: 'Description',
            name: (
                <div className="column-container">
                    <span>Description</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 243,
            renderCell: ({ row }) => {
                return (
                    <div className="validation_message" title={row.Description}>{row.Description}</div>
                );
            },
        },
        {
            key: 'AddedBy',
            name: (
                <div className="column-container">
                    <span>Added By</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 120,

        },
        {
            key: 'AddedDate',
            cellClass: 'last-column',
            headerCellClass: 'last-column',
            name: (
                <div className="column-container">
                    <span>Added Date</span>
                    <i className="icon-sorting fs-15" />
                </div>
            ),
            width: 120,
        },
    ]
    const LoadData = (searchParam) => {
        setRecOpened(false)
        setIsLoading(true);
        let SEARCHCRITERIA = {
            "Search": searchParam,
            "SearchType": "All",
        }
        ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Diagnosis,
            "SEARCHCRITERIA": SEARCHCRITERIA,
            "value": active === true ? '1' : '0',
            'PERPAGE': PerPage,
            'PAGENO': PageNo
        })
            .then((response) => {
                setRecICD(response.Rows)
                setTotalPages(response.count.NumOfPages);
                setIsLoading(false);
            }).catch((error) => {
                setRecICD([])
                setIsLoading(false);
            })
    }
    const SearchOnEnter = (e, type) => {
        if (e.key === "Enter") {
            if (type === 'DX') {
                setSearchParamDX(e.target.value)
                LoadPatientDXData(e.target.value)
            } else {
                setSearchParam(e.target.value)
                LoadData(e.target.value)
            }

        }
    }
    const onSelectDiagnosis = () => {
        handleSelectDiagnosis(recICD, Name)
    }
    useEffect(() => {
        setRecOpened(true)
        let SEARCHCRITERIA = {
            "Search": searchParam,
            "SearchType": "Recent",
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Diagnosis,
            "SEARCHCRITERIA": SEARCHCRITERIA,
            "value": active === true ? '1' : '0',
            'PERPAGE': PerPage,
            'PAGENO': PageNo
        })
            .then((response) => {
                setRecICD(response.Rows)
                setTotalPages(response.count.NumOfPages);
                setIsLoading(false);
            }).catch((error) => {
                setRecICD([])
                setIsLoading(false);
            })
    }, [])


    const LoadPatientDXData = (searchParam) => {
        setRecOpened(false)
        setIsLoading(true);
        let SEARCHCRITERIA = {
            "Search": searchParamDX,
            "PatientID": PatientID + "",
        }
        ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Diagnosis,
            "SEARCHCRITERIA": SEARCHCRITERIA,
            "value": active === true ? '1' : '0',
            'PERPAGE': PerPage,
            'PAGENO': PageNo
        })
            .then((response) => {
                setRecDxData(response.Rows)
                setTotalPages(response.count.NumOfPages);
                setIsLoading(false);
            }).catch((error) => {
                setRecDxData([])
                setIsLoading(false);
            })
    }
    useEffect(() => {
        setRecOpened(true)
        let SEARCHCRITERIA = {
            "Search": searchParam,
            "PatientID": PatientID + "",
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Diagnosis,
            "SEARCHCRITERIA": SEARCHCRITERIA,
            "value": active === true ? '1' : '0',
            'PERPAGE': PerPage,
            'PAGENO': PageNo
        })
            .then((response) => {
                setRecDxData(response.Rows)
                setTotalPages(response.count.NumOfPages);
                setIsLoading(false);
            }).catch((error) => {
                setRecDxData([])
                setIsLoading(false);
            })
    }, [])
    return (
        <Modal show={isOpenICDSearch} onHide={onCloseICD} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal ar_palceholder za-diagnose-history">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <ModalHeader HeaderName={dgheading} DeletePopup={""} isClosed={onCloseICD} key={''} Name={'DiagnosisSerach'} />
                <div className=' br-clr mt-2'>
                    <div className="row">

                        {/* <div className="col-12">
                            <div className="form-check d-flex align-items-center gap-1">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="active"
                                    value={active}
                                    onChange={() => setActive(!active)}
                                />
                                <label className="form-check-label" for="active">Include Inactive codes</label>
                            </div>
                        </div> */}
                        <div className="col-12">
                            <div className="pt-2 add_block_appointment w-100">
                                <div className='patient_payment_tabs'>
                                    <Tab.Container defaultActiveKey="RecentlyAdded">
                                        <div className='ms-0'>
                                            <Nav variant="tabs" className="d-flex border-0 gx-0">

                                                <Nav.Item className="ar-copay-link ar-pad">
                                                    <Nav.Link eventKey="RecentlyAdded" className="text">Recently Added</Nav.Link>
                                                </Nav.Item>
                                                {!isNull(PatientID) ?
                                                    <Nav.Item className="ar-copay-link ar-pad">
                                                        <Nav.Link eventKey="PatientDX" className="text">Patient DX</Nav.Link>
                                                    </Nav.Item>
                                                    : null}
                                            </Nav>
                                        </div>
                                        <Tab.Content>


                                            <Tab.Pane eventKey="RecentlyAdded">
                                                <div className="col-12 mb-10 mt-10">
                                                    {/* <div className="col-md-11 px-0 "> */}
                                                    <div className="input col-12 popup_super_search pe-0">
                                                        <div className='input-group hk-input-search'>
                                                            <input type="text" className='form-control fc-xs'
                                                                placeholder='Search diagnosis codes by code or description….'
                                                                onChange={e => setSearchParam(e.target.value)}
                                                                onKeyDown={(e) => SearchOnEnter(e)}
                                                            />
                                                            <span className="input-group-text seraches" id="basic-addon2" onClick={() => LoadData(searchParam)}>
                                                                <i className="bi bi-search"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                    {/* <div className="col-md-4">
                                <div class="input"> 
                                    <select class="form-control rounded fc-xs" id="ProviderID" name="ProviderID">
                                        <option value="-1">Procedure Macros</option>
                                        <option value="4">PAYNE, NATHAN</option>
                                        <option value="5">OBERDORF, RODNEY</option>
                                        <option value="6">SCHOLNICK, KYLE</option>
                                        <option value="7">AZAR, EDWARD</option>
                                        <option value="8">HOLWEGE, MIRANDA</option>
                                        <option value="9">OGHOORIAN, EDWIN</option>
                                        <option value="17">MCGOWAN, GERALDINE</option>
                                    </select>
                                </div>
                            </div> */}
                                                    {/* <div className="master_head col-2 pe-0">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">
                                    <i className="icon-table-view" /> Show All
                                </button>
                            </div> */}
                                                </div>
                                                <div className="opened-block ar-grid-border">
                                                    <p className="heading">{recOpened ? 'Recently Opened' : 'Recently Searched'}</p>
                                                    <DataGrid
                                                        columns={columnsRecentlyAdded}
                                                        rows={recICD}
                                                        selectedRows={selectedRows}
                                                        headerRowHeight={25}
                                                        rowHeight={25}
                                                        onSelectedRowsChange={onRowSelection}
                                                        rowKeyGetter={rowKeyGetter}
                                                        className="custom_checkboxes_gird_two diagnosis_grid fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                                                    />
                                                    {/* <Pagination
                                    PerPage={PerPage}
                                    PageNo={PageNo}
                                    TotalPages={TotalPages}
                                    handlePageClick={handlePageClick}
                                    PreviousPage={PreviousPage}
                                    handleFingByCreteria={handleFingByCreteria}
                                    NextPage={NextPage}
                                /> */}
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="PatientDX">
                                                <div className="col-12 mb-10 mt-10">
                                                    {/* <div className="col-md-11 px-0 "> */}
                                                    <div className="input col-12 popup_super_search pe-0">
                                                        <div className='input-group hk-input-search'>
                                                            <input type="text" className='form-control fc-xs'
                                                                placeholder='Search….'
                                                                onChange={e => setSearchParamDX(e.target.value)}
                                                                onKeyDown={(e) => SearchOnEnter(e, 'DX')}
                                                            />
                                                            <span className="input-group-text seraches" id="basic-addon2" onClick={() => LoadPatientDXData(searchParam)}>
                                                                <i className="bi bi-search"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="opened-block ar-grid-border">
                                                    <p className="heading">{recOpened ? 'Recently Opened' : 'Recently Searched'}</p>
                                                    <DataGrid
                                                        columns={columnsPatientDx}
                                                        rows={recDxData}
                                                        selectedRows={selectedRows}
                                                        headerRowHeight={25}
                                                        rowHeight={25}
                                                        onSelectedRowsChange={onRowSelection}
                                                        rowKeyGetter={rowKeyGetter}
                                                        className="custom_checkboxes_gird_two diagnosis_grid fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                                                    />
                                                    {/* <Pagination
                                                            PerPage={PerPage}
                                                            PageNo={PageNo}
                                                            TotalPages={TotalPages}
                                                            handlePageClick={handlePageClick}
                                                            PreviousPage={PreviousPage}
                                                            handleFingByCreteria={handleFingByCreteria}
                                                            NextPage={NextPage}
                                                        /> */}
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>


                                </div>
                            </div>




                        </div>
                        {/* <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-gray">Cancel</button>
                            <button className="btn btn-orange " >Select</button>
                        </div> */}
                    </div>
                </div>
            </Modal.Body>
            <div className="za_footer d-flex align-items-center pb-15 px-10 pt-2 br-top-1 br-clr justify-content-end gap-2">
                <button className='btn btn-outline btn-xs no-width rounded px-10' onClick={onCloseICD}>Cancel</button>
                <button className='btn btn-validate btn-xs no-width rounded px-10' onClick={onSelectDiagnosis}>Select</button>
            </div>
        </Modal>
    )
}

export default DiagnosisSearch